

import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import { routes } from "./routes/index";
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/pt-br'


Vue.use(Element,{ locale })

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    conteudo: '',
    mes:0,
    ano:2025,
    calendarioCompleto:true,
    nomeObri:''
  },
  mutations: {
    updateCalendarioCompleto(state, newCalendarioCompleto) {
      state.calendarioCompleto = newCalendarioCompleto
    },
    updateConteudo(state, newConteudo) {
      state.conteudo = newConteudo
    },
    updateAno(state,newAno){
      state.ano = newAno
    },
    updateMes(state,newMes){
      state.mes = newMes
    }
    
  },
  actions: {
    updateCalendarioCompleto(context, newCalendarioCompleto) {
      context.commit('updateCalendarioCompleto', newCalendarioCompleto)
    },
    updateConteudo(context, tree) {
      context.commit('updateConteudo', tree)
    },
    updateAno(context, tree) {
      context.commit('updateAno', tree)
    },
    updateMes(context, tree) {
      context.commit('updateMes', tree)
    },
  },
  getters: {
    calendarioCompleto(state){
      return state.calendarioCompleto
    },
    ano(state){
      return state.ano
    },
    mes(state){
      return state.mes
    },
    conteudo(state) {
      return state.conteudo
    }
  }
})

Vue.use(VueAxios, axios)
Vue.use(VueRouter)


Vue.config.productionTip = false
const router = new VueRouter({
  routes,
  mode: 'history'
});

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
